import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1400px] flex-1 flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <p className="font-label text-6xl font-black text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">这个页面不存在</h1>
        <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm leading-6 text-foreground-500">
          链接可能已失效，或者页面地址输入有误。你可以回到首页，或直接去影视分类继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            浏览影视分类
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}